"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Copyright (c) 2015-present, Zippy Technologies
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function sum(a, b) {
  return a + b;
}

/**
 * Returns an object with the keys:
 * getGroupedItems([30], [30], [40], dropdownButtonSize)
 * {
 *   visibleIndexes: Number[], - a list of indexes that are visible
 *   overflowItem: Number[], - a list of indexes that don't fit
 * }
 * @param  {Number[]} boxes              a list of box sizes to fit into maxSize
 * @param  {Number} overflowControlSize the size of the overflow control
 * @return {{
 *   visibleIndexes: [],
 *   overflowIndexes: [],
 * }}|null - an object with visible and overflow indexes, or null if it doesn't oveflow
 */
function getGroupedItems(_ref) {
  var boxes = _ref.boxes,
      maxSize = _ref.maxSize,
      _ref$overflowControlS = _ref.overflowControlSize,
      overflowControlSize = _ref$overflowControlS === undefined ? 0 : _ref$overflowControlS;

  // check if they fit
  var boxesSize = boxes.reduce(sum);
  if (boxesSize <= maxSize) {
    return false;
  }

  var availableSize = maxSize - overflowControlSize;

  var groups = boxes.reduce(function (acc, box, index) {
    if (availableSize - box >= 0) {
      // then it fits
      acc.visibleIndexes.push(index);
      availableSize -= box;
    } else {
      availableSize = 0;
      acc.overflowIndexes.push(index);
    }

    return acc;
  }, { visibleIndexes: [], overflowIndexes: [] });

  return groups;
}

exports.default = getGroupedItems;